export class AccountData {
    name = ""; 
    accountid = ""; 
    primaryTechnicalFirstName = ""; 
    primaryTechnicalLastName = ""; 
    primaryTechnicalUserName = ""; 
    primaryTechnicalUserId = 0;
    primaryTechnicalEmail = ""; 
    secondaryTechnicalFirstName = "";
    secondaryTechnicalLastName = "";
    secondaryTechnicalUserName = "";
    secondaryTechnicalUserId = 0;
    secondaryTechnicalEmail = "";
    operationsManagerFirstName = "";
    operationsManagerLastName = "";
    operationsManagerUserName = "";
    operationsManagerUserId = 0;
    operationsManagerEmail = "";
    territory = "";
}